import React from 'react';
import { Link } from 'react-router-dom';
import FormItem from '../../general/formitem.js';

export default class Cart extends React.Component
{
    constructor(props) {
        super(props);
        this.autoAddToCart = this.autoAddToCart.bind(this);
        this.state = {
            courseId: this.props.courseId
        }
    }
    componentDidMount() {
        this.autoAddToCart();
    }

    autoAddToCart() {
        if (this.state.courseId !== undefined) {
            this.props.api.send({
                controller: "Cart",
                action: "AddToCart",
                method: "post",
                debug: true,
                body: JSON.stringify({ CourseID: this.state.courseId }),
                success: (result) => {
                    if (result.success) {
                        this.props.loadCart();
                    }
                },
                error: (err) => {
                    console.log(err);
                }
            });
        }
        else {
            console.log("CourseID not found!");
        }
    }
    render()
    {
        const buytypes = [
            {name: "Myself", value: 0},
            {name: "All Users in my Organization", value: 1},
            {name: "Specific Users in my Organization", value: 2}
        ];
        const userList = this.props.cart.loaded ? this.props.orgUsers.map((u) =>
            <tr key={u.userID}>
                <td>{u.username}</td>
                <td>
                    <input type="checkbox" checked={this.props.cart.cartUsers.indexOf(u.userID) !== -1}
                        onChange={(e) => this.props.checkCartUserChanged(e.target.checked, u.userID)} />
                </td>
            </tr>
        ) : null;
        console.dir(this.props.cart.cartCourses);
        const cartcourselist = this.props.cart.cartCourses.map((c) =>
            <tbody key={c.courseID}>
                <tr>
                    <td>
                        <strong>{c.courseName}</strong>
                        <p>
                            {c.courseDescription.length < 120 ? c.courseDescription : c.courseDescription.substring(0, 120) + "..."}
                        </p>
                        {c.courseVolumeDiscounts.length > 0 ? (
                            <div>
                                <strong>Volume Discounts:</strong>
                                {c.courseVolumeDiscounts.map((d) => 
                                    <div key={d.userThreshold}>
                                        {d.userThreshold} Users: {d.price.toFixed(2)}
                                    </div>
                                )}
                            </div>
                        ) : null}
                    </td>
                    <td>${c.coursePrice.toFixed(2)}</td>
                </tr>
                <tr>
                    <td><strong>Total (${c.unitPrice ? c.unitPrice.toFixed(2) : 0.00} @ {c.usrCount ? c.usrCount : 0} Users):</strong></td>
                    <td>
                        <strong>${c.courseTotal ? c.courseTotal.toFixed(2) : 0.00.toFixed(2)}</strong>
                    </td>
                </tr>
            </tbody>
        );
        return (
            <div className="lmsdisplayarea">
                <h3>My Cart</h3>
                {this.props.cart.loaded ? (
                    <div>
                        {this.props.cart.cartCourses.length > 0 ? (
                            <div>
                                {this.props.cart.cartCourses[0].singleUser === false ? 
                                    (
                                        <div className="lmsdivmargin">
                                            <FormItem label="Buy For:" name="buytype" type="radiobuttons" options={buytypes} className="lmsformitemleft"
                                                value={this.props.cart.buyType} inputChanged={(e) => this.props.buyTypeChanged(e.target.value)} />
                                            {this.props.orgUsers.length > 0 && Number(this.props.cart.buyType) === 2 ? (
                                                <table className="lmstable lmsshortusertable">
                                                    <tbody>
                                                        <tr>
                                                            <th colSpan="2">
                                                                <input type="button" className="lmsbutton" value="Select All" onClick={(e) => this.props.cartUserSelectAll()} />
                                                                <input type="button" className="lmsbutton" value="Deselect All" onClick={(e) => this.props.cartUserDeselectAll()} />
                                                            </th>
                                                        </tr>
                                                        {userList}
                                                    </tbody>
                                                </table>
                                            ) : null}
                                        </div>
                                ) : null}
                                <div className="lmstablecontainer">
                                    <table className="lmstable">
                                        {cartcourselist}
                                    </table>
                                </div>
                                <div className="lmsgrandtotal">
                                    <strong>Grand Total:</strong> ${this.props.cart.grandTotal.toFixed(2)}
                                </div>
                                {this.props.anonymousCart ? 
                                    <div>
                                        <Link to="/Login" className="lmsbutton">Login to Checkout</Link>
                                        <Link to="/Register" className="lmsbutton">Register to Checkout</Link>
                                    </div>
                                    :
                                    <Link to="/Checkout" className="lmsbutton">Continue to Checkout</Link>
                                }
                            </div>
                        ) : (
                            <div>
                                You have no courses in your cart.  Check out our <Link to="/Shop" className="bodylink">Course Catalog</Link>.
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/course/catalog/cart.js